import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import Footer from "../Footer/Footer";
import MenuBar from "../MenuBar/MenuBar";
import { blackBoxSingleTitle, ButtonSecondaryHover, ButtonTextStyle, themeColors } from "../utils/MUIStylePresets";

export default function MentionsLegalesPage() {
  const ultraMobile = useMediaQuery("(max-width:500px)");

  const scrollToEl = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Stack
      direction="row"
      justifyContent={"center"}
      alignItems={"center"}
      mx={"5%"}
      mt={"2%"}
    >
      <Box maxWidth={1550} width="100%">
        <MenuBar scrollToEl={scrollToEl} />
        <Box mt={2}>
          <Box mt={10}>
            <Typography
              sx={blackBoxSingleTitle}
              color="primary"
              variant={"extrabold"}
            >
              Impressum
            </Typography>
          </Box>
          <Box mt={ultraMobile ? 1 : 5} pl={4}>
            <Box mb={4}>
              <Typography variant={"bookbold"} component="h2" sx={{ color: themeColors("text") }}>
                Exploitant du site
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                NextUp Solutions Sàrl
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }}>
                Côte-à-Deux-Sous 6
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }}>
                1052 Le Mont-sur-Lausanne, Suisse
              </Typography>
              <Button sx={{ ...ButtonSecondaryHover, mt: 2, pl: 0 }} href="mailto:hello@nxup.ch">
                <Typography variant={"book"} sx={ButtonTextStyle(themeColors("secondary"))}>
                  Contact
                </Typography>
              </Button>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                Inscrite au Registre du commerce du Canton de Vaud
              </Typography>
            </Box>

            <Box mb={4} mt={6}>
              <Typography variant={"bookbold"} component="h2" sx={{ color: themeColors("text") }}>
                Propriété intellectuelle
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                L'ensemble du contenu de ce site (textes, images, logos, graphismes) est la propriété de NextUp Solutions Sàrl ou de ses partenaires et est protégé par le droit suisse, notamment la Loi fédérale sur le droit d'auteur (LDA). Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.
              </Typography>
            </Box>

            <Box mb={4} mt={6}>
              <Typography variant={"bookbold"} component="h2" sx={{ color: themeColors("text") }}>
                Protection des données
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                Les données personnelles collectées sur ce site sont traitées conformément à la Loi fédérale sur la protection des données (nLPD). Pour toute question relative à vos données personnelles, vous pouvez nous contacter via le bouton Contact ci-dessus.
              </Typography>
            </Box>

            <Box mb={4} mt={6}>
              <Typography variant={"bookbold"} component="h2" sx={{ color: themeColors("text") }}>
                Responsabilité
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                NextUp Solutions Sàrl s'efforce d'assurer l'exactitude des informations publiées sur ce site, mais décline toute responsabilité en cas d'erreurs, d'omissions ou de résultats obtenus suite à l'utilisation de ces informations. Les liens vers des sites tiers sont fournis à titre informatif et n'engagent pas la responsabilité de NextUp Solutions Sàrl.
              </Typography>
            </Box>

            <Box mb={4} mt={6}>
              <Typography variant={"bookbold"} component="h2" sx={{ color: themeColors("text") }}>
                Droit applicable et for juridique
              </Typography>
              <Typography variant={"book"} component="p" sx={{ color: themeColors("text") }} mt={2}>
                Le droit suisse est applicable. Le for juridique est au siège de la société, sauf disposition légale contraire.
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box mt={15}>
          <Footer />
        </Box>
      </Box>
    </Stack>
  );
}
